module.exports = __webpack_public_path__ + "img/lock.092048b7.svg";